// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__iL-D1","label":"CategoryService_label__MIrVG","location":"CategoryService_location__dig96"};